const Breakpoint = {
    DESKTOP_AND_UP: "min-width: 1200px",
    TABLET_AND_DOWN: "max-width: 1200px",
    PHONE_AND_DOWN: "max-width: 600px",
} as const;

export type BreakpointType = typeof Breakpoint[keyof typeof Breakpoint];

export default Breakpoint;
